<template>
  <a-modal v-model="modal" :title="title" width="450px" :maskClosable="false" :closable="false">
    <a-form-model :model="formData" ref="form">
      <a-form-model-item
        label="需求交期"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="demandDate"
        :rules="rules.demandDate"
        v-if="fieldType==='demandDate'"
      >
        <a-date-picker v-model="formData.demandDate" valueFormat="YYYY-MM-DD 00:00:00" style="width: 80%" :disabled-date="disabledEndDate" />
      </a-form-model-item>
      <a-form-model-item
        label="供应商选择"
        :labelCol="{ style: 'width: 100px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 100px ) !important;float:left'}"
        prop="supplierCode"
        :rules="rules.supplierCode"
        v-if="fieldType==='supplierCode'"
      >
        <a-select
          allowClear
          show-search
          option-filter-prop="children"
          v-model="formData.supplierCode"
          option-label-prop="label">
          <a-select-option v-for="(item) in supplierList" :key="item.realValue" :value="item.realValue" :label="item.label">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment';
import { apiScpAdjustDeliveryDate, apiScpAdjustSupplier, apiAdjustSupplierComboBox } from '@/api/finished-goods-order'

export default {
  name: 'BatchEditModal',
  data() {
    return {
      modal: false,
      title: '批量修改',
      supplierList: [],
      formData: { demandDate: '', supplierCode: '' },
      loading: false,
      rules: {
        supplierCode: [{ required: true, message: ' ', trigger: 'change' }],
        demandDate: [{ required: true, message: ' ', trigger: 'change' }]
      },
      fieldType: '', // 修改字段标识
      ids: [],
      selectRow: []
    }
  },
  methods: {
    moment,
    show (field, ids, selectRow) {
      this.fieldType = field // 区分修改字段标识
      this.title = field === 'supplierCode' ? '调整供应商' : '批量修改'
      this.ids = ids || []
      this.selectRow = selectRow || []
      if (field === 'supplierCode') {
        this.initGetSupplier()
      }
      this.formData.demandDate = ""
      this.formData.supplierCode = ""
      this.modal = true
    },
    // 初始化获取供应商列表
    initGetSupplier() {
      const supplierCodeList = this.selectRow?.map(v => v.itemCode) || []
      this.loading = true
      apiAdjustSupplierComboBox(supplierCodeList).then(response => {
        if (response.code === 200) {
          this.supplierList = response?.data || []
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 提交
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          const params = { ids: this.ids }
          const urlServe = this.fieldType === 'supplierCode' ? apiScpAdjustSupplier : apiScpAdjustDeliveryDate
          if (this.fieldType === 'supplierCode') {
            params.supplierCode = this.formData.supplierCode
          } else if (this.fieldType === 'demandDate') {
            params.demandDate = this.$moment(this.formData.demandDate).format('YYYY-MM-DD HH:mm:ss')
          }
          this.loading = true;
          urlServe(params).then(response => {
            if (response?.code === 200) {
              this.$message.success('修改完成')
              this.modal = false
              this.$emit("finallyUpdate")
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 交期不可选历史日期
    disabledEndDate (date) {
      return date && date.valueOf() < Date.now() - 86400000;
    }
  }
}
</script>

<style scoped>

</style>
